export default {"src":"/_next/static/media/CarouselArrow.110290ae.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};